import React from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import {Admin} from './components/Admin';
import {GroupList} from './components/GroupList';
import {MainLayoutContainer} from './components/MainLayout';
import {UserEdit} from './components/UserEdit';
import {UserList} from './components/UserList';
import {GroupEdit} from './components/GroupEdit';
import {MainMenu} from './components/Menu/MainMenu';
import {UserNew} from "./components/UserNew";
import {GroupNew} from "./components/GroupNew";


function App() {
  const mainLayout =
    <MainLayoutContainer menu={<MainMenu/>}>
      <Switch>
        <Route exact path="/" render={props => ''}/>

        <Route exact path="/users"><UserList/></Route>
        <Route exact path="/user/new"><UserNew/></Route>
        <Route exact path="/user/edit/:id"><UserEdit/></Route>

        <Route exact path="/groups"><GroupList/></Route>
        <Route exact path="/group/new"><GroupNew/></Route>
        <Route exact path="/group/edit/:id"><GroupEdit/></Route>

        {/*<Route exact path="/admin"><Admin/></Route>*/}

      </Switch>
    </MainLayoutContainer>
  ;

  return (
    <div className="App">
      <header className="App-header">
        <BrowserRouter>
          {mainLayout}
        </BrowserRouter>
      </header>
    </div>
  );
}

export default App;
